import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { useProfile } from "@/providers/user";
import React, { useState, useEffect } from "react";

interface UserAvatarProps {
  user_uuid: string | null;
  classNames?: string;
  version?: number;
}

function UserAvatarComponent({
  user_uuid,
  classNames,
  version,
}: UserAvatarProps) {
  console.log(
    `[UserAvatar] Rendering. UUID: ${user_uuid}, Version: ${version}`
  );

  const { profile } = useProfile();

  const [fallback, setFallback] = useState<string>("");

  const avatarSrc = user_uuid
    ? `/api/avatars/${user_uuid}${version !== undefined ? `?v=${version}` : ""}`
    : null;

  useEffect(() => {
    if (profile?.first_name && profile?.last_name) {
      setFallback(
        `${profile?.first_name[0].toUpperCase()}${profile?.last_name[0].toUpperCase()}`
      );
    } else if (profile?.email) {
      setFallback(profile?.email[0].toUpperCase());
    }
  }, [profile]);

  return (
    <Avatar className={`w-full h-full ${classNames ?? ""}`}>
      <AvatarImage src={avatarSrc ?? ""} alt="userAvatar" key={avatarSrc} />
      <AvatarFallback>{fallback}</AvatarFallback>
    </Avatar>
  );
}

const UserAvatar = React.memo(UserAvatarComponent);
export default UserAvatar;
